import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaThousandSeparator'
})
export class CommaThousandSeparatorPipe implements PipeTransform {

    public transform(value: number): string {
        if (!value) {
            return '0';
        }

        return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
}
